import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initGa4, trackPageView } from "@/utils/ga4";

const Ga4Tracker = () => {
  const location = useLocation();

  useEffect(() => {
    initGa4();
  }, [initGa4]);

  useEffect(() => {
    trackPageView(`${location.pathname}${location.search}`);
  }, [location.pathname, location.search, trackPageView]);

  return null;
};

export default Ga4Tracker;
